import styled from 'styled-components';

import { Table } from 'antd';

export const Content02 = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  border: 0.06rem solid #dadada;
  box-sizing: border-box;
  justify-content: center;
  padding: 1rem;
  background-color: #ffffff;
`;
export const TableGroup = styled(Table)`
  width: 100%;
`;

export const ColumnTableGroup = styled(Table.Column)`
  height: 10rem;
  color: #fff;
  line-height: 10rem;
  text-align: center;
  background: #364d79;
`;
